
riot.tag2('persons-list-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Контакты</div>\n    </yield>\n    <yield to="body">\n      <catalog object="Contact" cols="{parent.cols}" search="true" reload="false" dblclick="{parent.opts.submit.bind(this)}" disable-col-select="1" exception="{parent.opts.id}">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="date">{row.regDate}</datatable-cell>\n          <datatable-cell name="email">{row.email}</datatable-cell>\n          <datatable-cell name="discount">{row.discount}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var _this = this;

var self = this;

self.item = {};

self.cols = [{ name: 'id', value: '#' }, { name: 'date', value: 'Дата' }, { name: 'email', value: 'Email' }, { name: 'discount', value: 'Скидка' }];

self.submit = function () {
    var items = _this.tags.datatable.getSelectedRows();
    if (!items.length) return;
    self.item.idAuthor = items[0].id;
    self.item.customer = items[0].displayName;
    self.item.idCompany = null;
    opts.submit.bind(_this)();
};
});


// WEBPACK FOOTER //
// ./pages/persons/persons-list-select-modal.tag